/**
* Abstract Web Service interface that serves as a basis for other
* Web Service interfaces and provides common functionality
*
* @class AbstractWS
*/
var AbstractWS = function (parent) {
  var self = this;								// Convenience reference so the context
  // of 'this' becomes clearer

  self.callback = null;						// Callback function holder
  self.data = null;						// XML Data returned from service
  self.dataType = 'xml',					// Data type to pass/receive to the service
    self.errorHandler = function () { };			// Error handler to run if AJAX fails
  self.errorMessage = ko.observable(null);	// Observable error message
  self.name = 'AbstractWS';				// String for convenience (ex console.log'ging issues)
  self.method = ko.observable('GET');	// AJAX request method. Can also be set to POST
  self.params = {};						// Object of key/value parameters
  self.parent = parent;					// Back reference to container object
  self.retryCount = 0;						// Counter for checkResponseForError() method
  self.sendType = null;						// Allows for header hijackings
  self.serviceURL = ko.computed(function () {	// URL to AJAX to/for data
    return '';
  });
};


/**
* Method to add parameters that will be passed to the api service call
*
* @method addParam
* @param {String} sKey Name of the param to pass to the API
* @param {String} sName Value of the param to pass to the API
* @return {AbstractWS} Returns the view model as chainable, for best practice
*/
AbstractWS.prototype.addParam = function (sKey, sVal) {
  this.params[sKey] = sVal;

  // Return self (AbstractWS) to be chainable, for best practice
  return this;
};


/**
* Checks any POST request responses for errors, typically WSSIDException
*
* @method checkResponseForError
* @param {Object} caller
* @param {Object} callerArgs
* @return {Error|Null} Returns an error, if found
*/
AbstractWS.prototype.checkResponseForError = function (caller, callerArgs) {
  var err = null,
    cause = null,
    msg = null,
    msgWS = null,
    self = this;

  self.errorMessage(null);

  // If an error was found, examine the type. If the type
  if (self.data && self.data.firstChild && self.data.firstChild.nodeName == 'error') {
    err = $(self.data).find('cause');

    // WSSIDException
    if (err && err.attr('type') && err.attr('type') == 'WSSIDException') {
      self.retryCount++;

      if (self.retryCount < 5) {
        self.parent.wssidWS.doRequest(caller, caller.doRequest);
      }
    }
    // Hum-dinger... could be anything. Just show the raw error msg
    else {
      self.errorMessage(err.text);
    }

  }
  else {
    // No error appears to have occured, change the retryCount back to 0
    if (caller) {
      caller.retryCount = 0;
    }
  }

  return err;
};



/**
* Method to reset any params which might be passed to the service
*
* @method clearParams
* @return {AbstractWS} Returns the view model as chainable, for best practice
*/
AbstractWS.prototype.clearParams = function () {
  this.params = {};

  // Return self (AbstractWS) to be chainable, for best practice
  return this;
};


/**
* Method to remove a named parameter from the array of parameters
*
* @method deleteParam
* @param {String} sKey Name of the param to remove
* @return {AbstractWS} Returns the view model as chainable, for best practice
*/
AbstractWS.prototype.deleteParam = function (sKey) {
  delete this.params[sKey];

  // Return self (AbstractWS) to be chainable, for best practice
  return this;
};


/**
* This method creates a subscription (observable) in a ViewModel that
* is derived from a KnockoutJS observable variable contained in another
* object.
*
* @method dependentObservable
* @param {String} sParamName The name of the observable value to subscribe to
* @param {Object} oDependentObject An object containing the observable
* @return {ObservedVariable} Returns a reference to the observed variable
*                            contained by the dependent object
*/
AbstractWS.prototype.dependentObservable = function (sParamName, oDependentObject) {
  return ko.computed(function () {
    return oDependentObject[sParamName]();
  });
};



/**
* Requests data from the WS. Hands off processing to processData()
*
* @method doRequest
* @param {Function} fCallback Function body to be executed after the API call has returned
* @return {AbstractWS} Returns the view model as chainable, for best practice
*/
AbstractWS.prototype.doRequest = function (fCallback) {
  var self = this,
    headers = null;

  // Reset any previously held data
  self.data = null;

  // Ensure that this method is only called by a WS object derived from
  // this prototype. If not, exit gracefully.
  if (!self.name || !(self instanceof AbstractWS)) {
    // Return self (AbstractWS) to be chainable, for best practice
    return self;
  }

  // If a callback was passed in, hold on to it to be processed later once
  // the data has been returned.
  if (fCallback) {
    self.callback = fCallback;
  }

  // Request or send data to the server (serviceURL). Once the data is
  // returned, run the data through the processData() method. Almost every
  // instance of this object will define it's own processData() method.
  // In case an error occured, run the errorHandler() method.
  headers = self.headers();

  // Perform the call to the service
  // At the time of this authoring, data is being returned from the
  // service in XML format. It is hoped that data will be available
  // as JSON at a later date, at which time this prototype will require
  // updating.
  if (self.dataType === 'json' && self.method().toLowerCase() === 'post') {
    console.log(self.params);
  }

  $.ajax({
    url: self.serviceURL(),
    headers: headers,
    method: self.method(),
    dataType: self.dataType,
    data: self.params,
    cache: false,
    success: function (data) {
      self.processData(data);
    },
    error: function (jqXHR, textStatus, errorThrown) {
      console.log(jqXHR, 'error', errorThrown);
      if (errorThrown.toLowerCase() !== 'abort') {
        self.errorHandler(jqXHR, textStatus, errorThrown);
      }
    }
  });


  // Return self (AbstractWS) to be chainable, for best practice
  return self;
};


/**
* Calculate the headers to send. Would be nice to make this observable, but
* as it has a dependency on the wssid(), it's fine as a function.
*
* @method headers
* @return {Object} Returns an object to pass as headers to the AJAX request
*/
AbstractWS.prototype.headers = function () {
  var hdr = {};

  if (this.method().toLowerCase() != 'get') {
    hdr['X-WSSID-Authorization'] = this.parent.wssid();

    switch (this.dataType) {
      case 'json':
        hdr['Accept'] = 'application/json';

        if (this.sendType != null) {
          hdr['Content-Type'] = this.sendType;
        }
        else {
          hdr['Content-Type'] = 'application/json; charset=UTF-8';
        }
        break;

      default:
        hdr['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8';
        break;
    }
  }

  return hdr;
};


/**
* Helper function to add ability to pad zeros in front of an integer
*
* @method pad
* @param {Integer} iNumber number to pad with zeros
* @param {Integer} iLength total length of string after padding
* @return {String} the passed in string, padded with zeros to the iLength
*/
AbstractWS.prototype.pad = function (iNumber, iLength) {
  // Ensure that the number passed is a number
  iNumber = parseInt(iNumber, 0);

  // Get or default the length
  iLength = parseInt(iLength) || 2;

  // Only other to proceed with padding if the number was an Integer
  if (!isNaN(iNumber)) {

    // To get the length, convert the Integer into a String
    iNumber = '' + iNumber;

    // Iterate over the string until the length matches iLength
    while (iNumber.length < iLength) {
      iNumber = '0' + iNumber;
    }
  }

  return iNumber;
};


/**
* Processes the data returned from an API service call.
* This method is regularly overridden by derived WS objects to
* turn the resulting data into usable objects it represents.
*
* @method processData
* @param {XMLString} data XML data returned from the API service call
* @param {Boolean} bAvoidCallback Whether to skip the callback function
* @return {AbstractWS} Returns the view model as chainable, for best practice
*/
AbstractWS.prototype.processData = function (data, bAvoidCallback) {
  var self = this,
    err = null;

  // Store the data (XML) for console inspection
  self.data = data;

  // If the request was a POST, make sure we didn't run into a WSSIDEXCEPTION
  if (self.method().toLowerCase() == 'post') {
    err = self.checkResponseForError(self, null);
  }

  // If we know about a callback, run it and then clear the callback so it does
  // not get run again, unintented.
  if (err == null) {

    setTimeout(function () {
      if (self.callback != null && bAvoidCallback != true) {
        self.callback();
        self.callback = null;
      }
    }, 250);
  }

  // Return self (AbstractWS) to be chainable, for best practice
  return self;
};


/**
* Method to be overridden by subclassed objects. Allows to custom
* properties to be reset
*
* @method reset
* @return {AbstractWS} Returns the view model as chainable, for best practice
*/
AbstractWS.prototype.reset = function () {
  var self = this;

  self.data = null;
  self.errorMessage(null);
  self.clearParams();
  self.retryCount = 0;

  // Return self (AbstractWS) to be chainable, for best practice
  return this;
};


if (typeof exports !== 'undefined') {
  exports.AbstractWS = AbstractWS;
}
